import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';
import { getChartUnit } from 'Util';

const FearGreed = ({ data, title, showTitle=true, showTip=true, inverse=false }) => {
  
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data) {
      const lineColor = ['#5278f0', '#c60000', '#f9ca52'];

      const option = {
        animation: false,
        grid: {
          top: 10,
          right: 5,
          bottom: 5,
          left: 5,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            interval: Math.round(data.x.length/6),
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10,
            formatter: (value) => {
              const tmp = value.split('.')
              return tmp[0].substring(2,4) + '.' + tmp[1]
            }
          },
          data: data.x
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 10,
            },
            min: 0,
            max: 100,
          },
          {
            inverse: inverse,
            type: 'value',
            axisLabel: {
              fontSize: 10,
            },
            min: function (value) {
              var cap = value.max - value.min;
              const unit = getChartUnit(cap);
              if (value.min % unit === 0) {
                return value.min;
              } else {
                return value.min - (value.min % unit);
              }
            },
          }
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 10
          },
        },
        series: [
          {
            name: title[0],
            data: data.y1,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[0] },
            lineStyle: { color: lineColor[0], width: 1 },
          },
          {
            name: title[1],
            data: data.y2,
            yAxisIndex: 1,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[1] },
            lineStyle: { color: lineColor[1], width: 1 },
          },
        ],
      }
      setOptions(option);
    }
  }, [data, title, inverse]);

	return (
    <>
      { showTitle &&
        <div className="title"><img src="/static/images/icon_timer.svg" alt="" />{title[0]} Market Watch</div>
      }
      <div className="fg_graph">
        <div className="lt">
          <div className="gauge">
            <span className="txt"><img src="/static/images/icon_imoji1.png" alt="" />탐욕</span>
            <span className="bar"></span>
            <span className="txt"><img src="/static/images/icon_imoji2.png" alt="" />공포</span>
          </div>
        </div>
        <div className="rt">
          <div className="chart" style={{height: '180px'}}>
            { options && 
              <ECharts option={options} style={{ width: '100%', height: '100%' }} />
            }
          </div>
          <div className="label">
            <span><i className="label_blue"></i><p>{title[0]}</p></span>
            <span><i className="label_red"></i><p>{title[1]}</p></span>
            {/* <span><i className="label_yellow"></i><p>KOSPI</p></span> */}
          </div>
        </div>
      </div>
      { showTip &&
        <div className="tip">{title[0]} 마켓워치의 흐름을 보실 수 있습니다.</div>
      }
    </>
  );
}

export default FearGreed;
